// extracted by mini-css-extract-plugin
export var container = "Onboarding-module--container--Wb+Wh";
export var content = "Onboarding-module--content--u9tLK";
export var contentWrapper = "Onboarding-module--contentWrapper--1tYE-";